import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// Vee Validate Language
import { localize } from "vee-validate/dist/vee-validate.full.esm";
import br_BR from 'vee-validate/dist/locale/pt_BR.json';
localize('pt-BR', br_BR);

// Vee Validate Validations
import './helpers/validations';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faSignOutAlt, faBars, faTimes,
    faHome, faFileDownload, faFilter,
    faEllipsisV, faListUl, faKey, faBell,
    faFileInvoice, faCircle, faUserEdit
} from "@fortawesome/free-solid-svg-icons";

library.add(faSignOutAlt);
library.add(faBars);
library.add(faTimes);
library.add(faHome);
library.add(faFileDownload)
library.add(faFilter);
library.add(faEllipsisV);
library.add(faListUl);
library.add(faKey);
library.add(faKey);
library.add(faBell);
library.add(faFileInvoice);
library.add(faCircle);
library.add(faUserEdit);

// App Styles
import './helpers/font.scss';
import './helpers/reset.scss';
import './helpers/helpers.scss';
import './helpers/input.scss';
import './helpers/button.scss';
import './helpers/alert.scss';
import './helpers/header.scss';
import './helpers/sidebar.scss';
import './helpers/card.scss';
import './helpers/notification.scss';

// OneSignal initialization
window.OneSignal = window.OneSignal || [];
window.OneSignal.push(() => {
    window.OneSignal.init({        
        appId: "3f5202ef-458f-4afc-bf5b-0d2f8df2eff9",
        allowLocalhostAsSecureOrigin: process.env.NODE_ENV !== 'production',
    });    
});

// Vue instance
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
